import { useState, useEffect } from 'react';
import useToken from './useToken';
import axios from 'axios';

import { SHIPPING_SERVICE_URL } from '../services';

export interface CheckRequestIdData {
  RequestId: string;
  fromHistory?: boolean;
}

export enum RequestStatusCode {
  Approvable = 1,
  Invalid = 2,
  Exists = 3,
  ExpiredOrConfirmed = 4,
}

interface ShipmentInqueryResult {
  comment: string;
  data?: {
    creationDate: string;
    delivedDateTime: string;
    deliveryDate: string;
    destinationAddress: string;
    destinationCity: string;
    destinationCounty: string;
    destinationId: string;
    destinationIdentification: string;
    destinationName: string;
    destinationProvince: string;
    id: string;
    shipmentCount: string;
    shipmentWeight: string;
    sourceAddress: string;
    sourceCity: string;
    sourceCounty: string;
    sourceId: number;
    sourceIdentification: string;
    sourceName: string;
    sourceProvince: string;
    templateName: string;
    plate: string;
  };
  isSuccess: boolean;
  message: string;
  statusCode: RequestStatusCode;
}

interface CheckRequestIdOptions {
  skip?: boolean;
}

function useGetInquery(data: CheckRequestIdData, options?: CheckRequestIdOptions) {
  const { RequestId } = data;
  const { skip = false } = options || {};
  const { token, decode: Decoder, reftech } = useToken();

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<ShipmentInqueryResult>();

  const url = `${SHIPPING_SERVICE_URL}/verification/inquiry/${RequestId.replace('RNSO-', '')}`;
  useEffect(() => {
    if (skip || !token || !!result) return;
    axios(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      validateStatus: (status) => status < 500,
    })
      .then(async (response) => {
        console.log(response);
        if (response.status === 401) return reftech();
        if (response.status === 403) return reftech();
        setResult(response.data);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, token, RequestId]);

  return { loading, data: result, Decoder };
}

export default useGetInquery;
